import { IVisaPrepForm, IPhone } from '../../../../../../types/index.d';
import { isPersonTravellingWith } from '../../../../../../utilities/pages';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasDependantChildren'
  | 'children'
  | 'childrenLivingWithYou'
  | 'contactAddress'
  | 'contactCity'
  | 'contactCountry'
  | 'contactPostcode'
> & {
  contactNumber?: IPhone;
};

type Params = Fields & {
  isPhoneNumberValid: boolean;
};

export function getPageStatus({
  hasDependantChildren,
  children,
  childrenLivingWithYou,
  contactAddress,
  contactCity,
  contactCountry,
  contactPostcode,
  contactNumber,
  isPhoneNumberValid
}: Params): { complete: boolean } {
  let complete = true;

  if (hasDependantChildren === false) {
    complete = true;
  } else {
    if (
      childrenLivingWithYou === undefined ||
      (childrenLivingWithYou === false &&
        (contactAddress === '' ||
          contactCity === '' ||
          contactCountry === '' ||
          contactNumber === undefined ||
          contactNumber.code === null ||
          contactNumber.phone === null ||
          !isPhoneNumberValid))
    ) {
      complete = false;
    }
    if (hasDependantChildren === true) {
      if (!children || children.length === 0) {
        complete = false;
      } else {
        complete =
          complete &&
          !children.some(details => {
            return (
              details.nationality === '' ||
              details.sameNationality === undefined ||
              details.familyName === '' ||
              details.givenName === '' ||
              details.dob === '' ||
              details.placeOfBirth === '' ||
              details.travellingWith === '' ||
              (isPersonTravellingWith(details.travellingWith) &&
                (details.ukVisa === undefined ||
                  details.hasPassport === undefined ||
                  (details.hasPassport === true && details.passportNumber === '')))
            );
          });
      }
    } else {
      complete = false;
    }
  }

  return { complete };
}
